document.addEventListener('DOMContentLoaded', function() {
  // Elementos del DOM
  const recoverPasswordLink = document.getElementById('RecoverPassword');
  const hideRecoverPasswordLink = document.getElementById('HideRecoverPasswordLink');
  const recoverPasswordForm = document.getElementById('RecoverPasswordForm');
  const loginForm = document.getElementById('CustomerLoginForm');
  const resetSuccess = document.getElementById('ResetSuccess');

  // Verificar si hay un hash en la URL para mostrar el formulario de recuperación
  if (window.location.hash === '#recover') {
    showRecoverPasswordForm();
  }

  // Eventos para mostrar/ocultar el formulario de recuperación
  if (recoverPasswordLink) {
    recoverPasswordLink.addEventListener('click', function(evt) {
      evt.preventDefault();
      showRecoverPasswordForm();
      window.location.hash = '#recover';
    });
  }

  if (hideRecoverPasswordLink) {
    hideRecoverPasswordLink.addEventListener('click', function(evt) {
      evt.preventDefault();
      hideRecoverPasswordForm();
      window.location.hash = '';
    });
  }

  // Funciones para mostrar/ocultar formularios
  function showRecoverPasswordForm() {
    loginForm.classList.add('hide');
    recoverPasswordForm.classList.remove('hide');
    
    // Desplazamiento suave hacia el formulario
    //recoverPasswordForm.scrollIntoView({ behavior: 'smooth' });
    
    // Enfoque en el campo de correo electrónico
    setTimeout(function() {
      document.getElementById('RecoverPasswordForm-email').focus();
    }, 200);
  }

  function hideRecoverPasswordForm() {
    loginForm.classList.remove('hide');
    recoverPasswordForm.classList.add('hide');
    window.location.hash = '';
  }

  // Verificar si se ha enviado correctamente el formulario de recuperación
  const resetPasswordSuccess = document.querySelector('.reset-password-success');
  if (resetPasswordSuccess) {
    resetSuccess.classList.remove('hide');
    resetSuccess.focus();
  }
});
